var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-viewer',{attrs:{"dataShape":_vm.dataShape,"selectedObject":_vm.object,"collectionDBname":_vm.collectionDBname}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }